import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import { Button } from "@/view/components/ui/button";
import useProposalReviewModal from "./useProposalReviewModal";
import masks from "@/app/utils/masks";

interface ProposalReviewModalProps {
  onContinue: () => void;
  onBack: () => void;
}

export default function ProposalReviewModal({
  onContinue,
  onBack,
}: ProposalReviewModalProps) {
  const {
    form,
    submitModal,
    personalFields,
    bankFields,
    isPending,
    proposalData,
  } = useProposalReviewModal({
    onContinue,
  });

  const RenderList = ({ data }: { data: any[] }) => (
    <div className="space-y-2">
      {data.map((item) => (
        <div key={item.label} className="flex justify-between py-1 text-sm">
          <span className="text-gray-500">{item.label}</span>
          <span className="text-right font-semibold">{item.value}</span>
        </div>
      ))}
    </div>
  );

  return (
    <DialogContent className="flex max-h-[90vh] flex-col overflow-y-auto sm:max-w-3xl">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-black01">
          Revisão da proposta
        </DialogTitle>
      </DialogHeader>

      <form onSubmit={submitModal} className="flex flex-1 flex-col">
        <FormProvider {...form}>
          <div className="mt-2 space-y-6">
            <div>
              <p className="text-base text-gray-600">Proposta</p>
              <p className="text-3xl font-semibold">
                {masks.currency(Math.round(Number(proposalData?.value) * 100))}
              </p>
            </div>

            <div>
              <div className="mb-2 flex items-center gap-2">
                <span className="text-xs font-medium">Dados pessoais</span>
                <div className="flex-1 border-t border-gray-300" />
              </div>
              <RenderList data={personalFields} />
            </div>

            <div>
              <div className="mb-2 flex items-center gap-2">
                <span className="text-xs font-medium">Dados bancários</span>
                <div className="flex-1 border-t border-gray-300" />
              </div>
              <RenderList data={bankFields} />
            </div>

            <div className="mt-8 flex items-center justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={onBack}
                className="w-[160px] rounded-full text-primary"
              >
                Voltar
              </Button>
              <Button
                isLoading={isPending}
                className="w-[160px] rounded-full font-semibold text-white"
                type="submit"
              >
                Prosseguir
              </Button>
            </div>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
